import { useState } from "react"
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { CustomDialog } from "../../components/Dialog/CustomDialog";
import { Skins } from "../../components/Loader/Skins";
import { results } from "../../services/resultsService";
import { useDispatch, useSelector } from "react-redux";
import { setResults } from "../../store/resultsSlice";

export const Results = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [completed, setCompleted] = useState(false);
    
    useEffect(() => {
        results().then(response => {
            const data = response.data;
            setIsLoading(false);
            setCompleted(true);
            setIsDialogOpen(false);
            // dispatch(setResults(data, "Results/setResults"))
        }).catch(err => {
            const status  = err.response.status;
            if(status === 403) {
                setIsDialogOpen(true);
                setIsLoading(false);
            }
        });
    }, [navigate, dispatch]);

    return (
        <>
            {isLoading && (<Skins />)}
            {completed ? (<Outlet />) : (<CustomDialog open={isDialogOpen} />)}
        </>
    )
}